import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilitiesService {

  public show: boolean = true;
  public loading: boolean = false;

  constructor() { }

  isAdmin() {
    let role = localStorage.getItem('role');

    if (role && role.toString().toLocaleLowerCase() === 'admin')
      return true;
    return false;
  }

  isAllowed(roles: any[]) {
    let role = localStorage.getItem('role');

    if (role && roles.includes(role.toString().toLocaleLowerCase()))
      return true;
    return false;
  }

  isDisabled(service: string, names: string[]) {
    if (names.includes(service.toLowerCase()))
      return true;
    return false;
  }
}
